export enum CreateServiceLocationSourceType {
  ServiceAccount = "ServiceAccount",
  Accounts = "Accounts",
  Depots = "Depots"
}
